import Vue from 'vue'
import App from './App.vue'
import VueLocalStorage from 'vue-localstorage'
import VueRouter from 'vue-router'
import GeneralMixin from '../../mixins/general'
import Api from '../../plugins/api'

// ↓レイアウト確定後、差し替え

Vue.config.productionTip = false

Vue.use(VueLocalStorage)
Vue.use(VueRouter)
Vue.use(Api)

// mixin
Vue.mixin(GeneralMixin)

// ルーティング設定
const routes = []

const router = new VueRouter({
    routes,
    mode: 'history',
})

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app')
